<div class="d-flex">
  <div class="col-lg-5 col-xl-4">
    <div class="d-flex gap-2 mb-2">
      @if (totalSiteCount > 0) {
        <div class="flex-grow-1">
          <gtapp-auto-complete
            [data]="siteDropDownList"
            placeHolder="Search Sites"
            searchKeyword="company_name"
            [itemTemplate]="siteTemplate"
            [initialValue]="siteSearchString"
            (inputChanged)="onSiteLookup($event)"
            (selected)="openSiteView($event)"
            (submitted)="
              clearValues(); siteSearchString = $event; getSiteListData()
            "
          >
          </gtapp-auto-complete>
          <ng-template #siteTemplate let-item>
            <div>{{ item?.company_name }}</div>
            @if (item?.full_address) {
              <div class="text-secondary small-font">
                {{ item?.full_address }}
              </div>
            }
          </ng-template>
        </div>
      }
      <div>
        <button
          id="addSite"
          class="btn btn-primary btn-lg w-100"
          (click)="openAddSiteForm()"
        >
          + Add Site
        </button>
      </div>
    </div>

    <gtapp-gt-custom-table
      [deskTopTableData]="sitePaginationData[pageNumSites] || []"
      [desktopTableDetails]="siteDetailsTableView"
      [tableStyle]="tableStyle"
      [otherParams]="otherParamsSites"
      (sortColumn)="sortColumnSite($event)"
      (searchColumn)="searchColumnSite($event)"
      (rowClick)="openSiteView($event)"
      (paginationChange)="onChangePaginationSite($event)"
    ></gtapp-gt-custom-table>
  </div>
  @if (selectedSite?.id) {
    <div class="col-lg-7 col-xl-8">
      <gtapp-view-site [siteId]="selectedSite?.id"></gtapp-view-site>
    </div>
  }
</div>
